import { PLATFORMS } from "@/lib/data";

export const Platforms = () => {
  const items = [...PLATFORMS, ...PLATFORMS, ...PLATFORMS];
  return (
    <section data-testid="platforms-section" className="bg-secondary py-14 md:py-20 border-y border-navy/10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 mb-8 flex items-center gap-4">
        <span className="text-gold-dark text-xs font-bold uppercase tracking-[0.3em] whitespace-nowrap">Drive for any platform</span>
        <div className="h-px bg-navy/10 flex-1" />
      </div>
      <div className="relative w-full overflow-hidden fade-mask-x">
        <div className="flex w-max marquee-slow items-center">
          {items.map((p, i) => (
            <span key={`${p.name}-${i}`} className="flex items-center shrink-0">
              <span className="font-heading font-extrabold text-navy text-4xl sm:text-6xl md:text-7xl tracking-tight px-8">
                {p.name}
              </span>
              <span className="w-2.5 h-2.5 rounded-full bg-gold shrink-0" />
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
